import React from "react";
import { Chart } from "react-google-charts";


class AcqCustSource extends React.Component {
	constructor(props) {
	    super(props);
	}

	render() {
		return (
			<p>Inside AcqCustSource Chart</p>
		)
	}
}

export default (AcqCustSource);


// WEBPACK FOOTER //
// ./src/views/Audiences/AcqCustSource.jsx